import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import { Icon } from '../../shared'
import './product-filter.scss'
import { CheckboxV2 } from '../../shared/checkbox'
import { observer } from 'mobx-react'
import { filterBarStore } from '../filter-bar'
import type { FilterTypes } from '../filter-bar/filter-bar.store'
import { toJS } from 'mobx'

interface IProps {
  type: keyof FilterTypes
}

const ProductMetafieldFilter: React.FC<IProps> = observer(({ type }) => {
  const [showFilter, setShowFilter] = useState(false)
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleUnclick = (e: MouseEvent): void => {
      if (showFilter && !wrapperRef?.current?.contains(e.target as Node)) {
        toggleFilter()
      }
    }

    document.addEventListener('click', handleUnclick)
    return () => {
      document.removeEventListener('click', handleUnclick)
    }
  }, [showFilter])

  const toggleFilter = (): void => {
    setShowFilter(!showFilter)
  }

  const resetFilters = () => {
    filterBarStore.setSelectedFiltersV2(type, [])
  }

  const toggleFilterItem = (title: string) => {
    const currentFilters = toJS(filterBarStore.selectedFiltersV2[type])
    const updatedFilters = currentFilters.includes(title) ? currentFilters.filter((filter) => filter !== title) : [...currentFilters, title]
    filterBarStore.setSelectedFiltersV2(type, updatedFilters)
  }

  const filtersList = (): React.ReactElement[] => {
    const options = filterBarStore.filterOptions[type]
    return options.map((name) => {
      return (
        <CheckboxV2
          isActive={filterBarStore.selectedFiltersV2[type].includes(name)}
          onClick={() => {
            toggleFilterItem(name)
          }}
          key={name}
          title={name}
        />
      )
    })
  }

  const capitalize = (str: string) => {
    if (typeof str !== 'string' || str.length === 0) {
      return str
    }

    if (str === 'dietary_preferences') {
      return 'Dietary Preferences'
    }

    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  const baseClass = 'product-filter'
  const numOfSelectedFilters = filterBarStore.selectedFiltersV2[type].length

  return (
    <div className={baseClass}>
      <div className={`${baseClass}__container`} ref={wrapperRef}>
        <button className='filter-button' onClick={toggleFilter}>
          <span className='filter-title'>{capitalize(type)}</span>
          <Icon icon='up' className={showFilter ? 'up' : 'down'} />
        </button>
        {showFilter && (
          <div className='filter-content'>
            <div className='header'>
              {`${numOfSelectedFilters} selected`}
              <span className='reset' onClick={resetFilters}>
                Reset all
              </span>
            </div>
            <ul>{filtersList()}</ul>
          </div>
        )}
      </div>
    </div>
  )
})

export default ProductMetafieldFilter
